import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/check-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 56C366.5 56 456 145.5 456 256 456 366.5 366.5 456 256 456 145.5 456 56 366.5 56 256 56 145.5 145.5 56 256 56M396.2 186.3L373.7 163.5C369 158.8 361.4 158.8 356.7 163.5L215.3 303.7 155.6 243.4C150.9 238.7 143.3 238.7 138.6 243.4L115.9 265.9C111.2 270.6 111.1 278.2 115.8 282.9L206.6 374.4C211.2 379.1 218.8 379.1 223.5 374.4L396.1 203.2C400.8 198.6 400.9 191 396.2 186.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/check-circle.js
// module id = DeYO
// module chunks = 144